import React, { Component } from "react";
import { connect } from "dva";
import { parse } from "qs";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import styles from "./index.less";

const { ListTable } = ListPage;

@connect(({ evaluateProcess }) => ({
  ...evaluateProcess
}))
class EvaluateProcessView extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId, groupId } = query;

    this.state = {
      currentProjectId,
      groupId,
      columns: [
        {
          title: "评估对象",
          dataIndex: "orgName",
          key: "orgId"
        }
      ]
    };
  }

  componentDidMount() {
    this.getDetail();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getList(pageInfo);
  };

  getDetail = pageInfo => {
    const { currentProjectId, groupId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "evaluateProcess/fetchGetSchedule",
      payload: {
        projectId: currentProjectId,
        userGroupId: groupId,
        page: 1,
        pageSize: 10,
        ...pageInfo
      },
      callback: this.setColumn
    });
  };

  setColumn = () => {
    const { orgScheduleList } = this.props;
    const { columns } = this.state;
    if (orgScheduleList.length) {
      orgScheduleList.forEach(orgItem => {
        orgItem.userScheduleList.forEach(userItem => {
          orgItem[
            userItem.userId
          ] = `${userItem.completeIndexCount}/${orgItem.orgIndexSum}`;
        });
      });
      orgScheduleList[0].userScheduleList.forEach(item => {
        columns.push({
          title: `${item.userName}`,
          dataIndex: `${item.userId}`,
          key: `${item.userId}`
        });
      });
    }
    this.setState({
      columns
    });
  };

  render() {
    const { spinProps, orgScheduleList, pageInfo } = this.props;
    const { columns } = this.state;
    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.process
    };

    const tableProps = {
      columns,
      rowKey: "id",
      list: orgScheduleList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };
    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          <div className="container">
            <ListTable {...tableProps} />
          </div>
        </ListPage>
      </Container>
    );
  }
}

export default EvaluateProcessView;
